/* tslint:disable */
/* eslint-disable */
/**
 * MAPIIO API
 * API mapové aplikace Mapiio pro klientskou JavaScriptovou / React část.
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { CatalogItemChildrenSwapVO } from '../model';
// @ts-ignore
import { CatalogItemDetailVO } from '../model';
// @ts-ignore
import { CatalogItemSelectStateVO } from '../model';
// @ts-ignore
import { FulltextSearchResultVO } from '../model';
// @ts-ignore
import { LayerDataUpdatedVO } from '../model';
// @ts-ignore
import { LayerSettingsVO } from '../model';
// @ts-ignore
import { TopicBaseVO } from '../model';
// @ts-ignore
import { TopicLightVO } from '../model';
// @ts-ignore
import { TopicTreeNodeVO } from '../model';
// @ts-ignore
import * as Objs from './index'
// @ts-ignore
import { DataResponseVO, DataRequestVO, ExportRequestVO } from '@mc/data-filter-react';

/**
 * LayerSettingsControllerApi - axios parameter creator
 * @export
 */
export const LayerSettingsControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Metoda co slouží k převedení jednoho (či více) children od dárce k příjemci, případně k přeorganizování pořadí u příjemce.
         * @param {CatalogItemChildrenSwapVO} catalogItemChildrenSwapVO List identifikátorů catalog itemů, u kterých se uloží nové uspořádání jejich child elementů
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeChildrenOrder: async (catalogItemChildrenSwapVO: CatalogItemChildrenSwapVO, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'catalogItemChildrenSwapVO' is not null or undefined
            assertParamExists('changeChildrenOrder', 'catalogItemChildrenSwapVO', catalogItemChildrenSwapVO)
            const localVarPath = `/api/settings/topic/topic-tree/change-children-order`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(catalogItemChildrenSwapVO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Metoda pro přidání catalog itemu / založení kategorie
         * @param {CatalogItemDetailVO} [catalogItemDetailVO] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCatalogItem: async (catalogItemDetailVO?: CatalogItemDetailVO, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/settings/catalog`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(catalogItemDetailVO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Metoda pro vytvoření vrstvy
         * @param {LayerSettingsVO} layerSettingsVO Objekt vrstvy
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createLayer: async (layerSettingsVO: LayerSettingsVO, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'layerSettingsVO' is not null or undefined
            assertParamExists('createLayer', 'layerSettingsVO', layerSettingsVO)
            const localVarPath = `/api/settings/layer`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(layerSettingsVO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Metoda pro vytvoření vrstvy a její přidání do kategorie
         * @param {string} topicId 
         * @param {number} [catalogItemParentId] 
         * @param {LayerSettingsVO} [layerSettingsVO] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createLayerWithCatalogItem: async (topicId: string, catalogItemParentId?: number, layerSettingsVO?: LayerSettingsVO, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'topicId' is not null or undefined
            assertParamExists('createLayerWithCatalogItem', 'topicId', topicId)
            const localVarPath = `/api/settings/layer-catalog`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (catalogItemParentId !== undefined) {
                localVarQueryParameter['catalogItemParentId'] = catalogItemParentId;
            }

            if (topicId !== undefined) {
                localVarQueryParameter['topicId'] = topicId;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(layerSettingsVO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Metoda pro vytvoření tématu
         * @param {TopicBaseVO} topicBaseVO Objekt tématu obsahující jen název
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTopic: async (topicBaseVO: TopicBaseVO, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'topicBaseVO' is not null or undefined
            assertParamExists('createTopic', 'topicBaseVO', topicBaseVO)
            const localVarPath = `/api/settings/topic`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(topicBaseVO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Metoda pro odebrání catalog itemu / odebrání kategorie
         * @param {number} catalogItemId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCatalogItem: async (catalogItemId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'catalogItemId' is not null or undefined
            assertParamExists('deleteCatalogItem', 'catalogItemId', catalogItemId)
            const localVarPath = `/api/settings/catalog`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (catalogItemId !== undefined) {
                localVarQueryParameter['catalogItemId'] = catalogItemId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Metoda pro odebrání vrstvy
         * @param {number} layerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteLayer: async (layerId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'layerId' is not null or undefined
            assertParamExists('deleteLayer', 'layerId', layerId)
            const localVarPath = `/api/settings/layer`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (layerId !== undefined) {
                localVarQueryParameter['layerId'] = layerId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Metoda pro smazání tématu
         * @param {string} topicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTopic: async (topicId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'topicId' is not null or undefined
            assertParamExists('deleteTopic', 'topicId', topicId)
            const localVarPath = `/api/settings/topic`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (topicId !== undefined) {
                localVarQueryParameter['topicId'] = topicId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Metoda co vrátí všechny dostupné entity pro přiřazení práv dle fulltextu
         * @param {string} fulltext Filtr pro fulltextové vyhledání
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEntitiesFulltext: async (fulltext: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'fulltext' is not null or undefined
            assertParamExists('getAllEntitiesFulltext', 'fulltext', fulltext)
            const localVarPath = `/api/settings/entities/fulltext`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (fulltext !== undefined) {
                localVarQueryParameter['fulltext'] = fulltext;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Metoda pro vrácení vrstvy
         * @param {number} layerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLayer: async (layerId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'layerId' is not null or undefined
            assertParamExists('getLayer', 'layerId', layerId)
            const localVarPath = `/api/settings/layer`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (layerId !== undefined) {
                localVarQueryParameter['layerId'] = layerId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Metoda pro zjištění data a času, ke kterému jsou aktualizována data vrstvy ve veřejné instanci Mapia (maximum data poslední publikace ze záznamů vrstvy).
         * @param {number} layerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLayerDataUpdated: async (layerId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'layerId' is not null or undefined
            assertParamExists('getLayerDataUpdated', 'layerId', layerId)
            const localVarPath = `/api/settings/layer/data-updated`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (layerId !== undefined) {
                localVarQueryParameter['layerId'] = layerId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Metoda pro načtení stromu dle topic id, vrací plochou strukturu s vazbami children/parent
         * @param {string} topicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTopicTree: async (topicId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'topicId' is not null or undefined
            assertParamExists('getTopicTree', 'topicId', topicId)
            const localVarPath = `/api/settings/topic/topic-tree`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (topicId !== undefined) {
                localVarQueryParameter['topicId'] = topicId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Metoda pro okamžité spuštění publikace jedné vrstvy do veřejné instance Mapia. Publikace běží na pozadí.
         * @param {number} layerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publishLayer: async (layerId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'layerId' is not null or undefined
            assertParamExists('publishLayer', 'layerId', layerId)
            const localVarPath = `/api/settings/layer/publish`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (layerId !== undefined) {
                localVarQueryParameter['layerId'] = layerId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Metoda pro update catalog itemu / kategorie
         * @param {number} catalogItemId 
         * @param {CatalogItemDetailVO} [catalogItemDetailVO] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCatalogItem: async (catalogItemId: number, catalogItemDetailVO?: CatalogItemDetailVO, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'catalogItemId' is not null or undefined
            assertParamExists('updateCatalogItem', 'catalogItemId', catalogItemId)
            const localVarPath = `/api/settings/catalog/update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (catalogItemId !== undefined) {
                localVarQueryParameter['catalogItemId'] = catalogItemId;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(catalogItemDetailVO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Metoda pro update vrstvy
         * @param {number} layerId 
         * @param {LayerSettingsVO} layerSettingsVO Objekt vrstvy
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateLayer: async (layerId: number, layerSettingsVO: LayerSettingsVO, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'layerId' is not null or undefined
            assertParamExists('updateLayer', 'layerId', layerId)
            // verify required parameter 'layerSettingsVO' is not null or undefined
            assertParamExists('updateLayer', 'layerSettingsVO', layerSettingsVO)
            const localVarPath = `/api/settings/layer`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (layerId !== undefined) {
                localVarQueryParameter['layerId'] = layerId;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(layerSettingsVO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Metoda pro (od)označení selected fieldech prvků catalog item
         * @param {string} topicId 
         * @param {Array<CatalogItemSelectStateVO>} catalogItemSelectStateVO List identifikátorů catalog itemů, u kterých se má provést (un)select
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSelectStates: async (topicId: string, catalogItemSelectStateVO: Array<CatalogItemSelectStateVO>, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'topicId' is not null or undefined
            assertParamExists('updateSelectStates', 'topicId', topicId)
            // verify required parameter 'catalogItemSelectStateVO' is not null or undefined
            assertParamExists('updateSelectStates', 'catalogItemSelectStateVO', catalogItemSelectStateVO)
            const localVarPath = `/api/settings/topic/topic-tree/select-states`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (topicId !== undefined) {
                localVarQueryParameter['topicId'] = topicId;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(catalogItemSelectStateVO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Metoda pro update tématu
         * @param {string} topicId 
         * @param {TopicBaseVO} topicBaseVO Objekt tématu
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTopic: async (topicId: string, topicBaseVO: TopicBaseVO, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'topicId' is not null or undefined
            assertParamExists('updateTopic', 'topicId', topicId)
            // verify required parameter 'topicBaseVO' is not null or undefined
            assertParamExists('updateTopic', 'topicBaseVO', topicBaseVO)
            const localVarPath = `/api/settings/topic`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (topicId !== undefined) {
                localVarQueryParameter['topicId'] = topicId;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(topicBaseVO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Metoda pro update settings tématu
         * @param {string} topicId 
         * @param {TopicLightVO} topicLightVO Objekt tématu
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTopicSettings: async (topicId: string, topicLightVO: TopicLightVO, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'topicId' is not null or undefined
            assertParamExists('updateTopicSettings', 'topicId', topicId)
            // verify required parameter 'topicLightVO' is not null or undefined
            assertParamExists('updateTopicSettings', 'topicLightVO', topicLightVO)
            const localVarPath = `/api/settings/topic/settings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (topicId !== undefined) {
                localVarQueryParameter['topicId'] = topicId;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(topicLightVO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LayerSettingsControllerApi - functional programming interface
 * @export
 */
export const LayerSettingsControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = LayerSettingsControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * Metoda co slouží k převedení jednoho (či více) children od dárce k příjemci, případně k přeorganizování pořadí u příjemce.
         * @param {CatalogItemChildrenSwapVO} catalogItemChildrenSwapVO List identifikátorů catalog itemů, u kterých se uloží nové uspořádání jejich child elementů
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async changeChildrenOrder(catalogItemChildrenSwapVO: CatalogItemChildrenSwapVO, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {

            const localVarAxiosArgs = await localVarAxiosParamCreator.changeChildrenOrder(catalogItemChildrenSwapVO, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Metoda pro přidání catalog itemu / založení kategorie
         * @param {CatalogItemDetailVO} [catalogItemDetailVO] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createCatalogItem(catalogItemDetailVO?: CatalogItemDetailVO, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {

            const localVarAxiosArgs = await localVarAxiosParamCreator.createCatalogItem(catalogItemDetailVO, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Metoda pro vytvoření vrstvy
         * @param {LayerSettingsVO} layerSettingsVO Objekt vrstvy
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createLayer(layerSettingsVO: LayerSettingsVO, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {

            const localVarAxiosArgs = await localVarAxiosParamCreator.createLayer(layerSettingsVO, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Metoda pro vytvoření vrstvy a její přidání do kategorie
         * @param {string} topicId 
         * @param {number} [catalogItemParentId] 
         * @param {LayerSettingsVO} [layerSettingsVO] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createLayerWithCatalogItem(topicId: string, catalogItemParentId?: number, layerSettingsVO?: LayerSettingsVO, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {

            const localVarAxiosArgs = await localVarAxiosParamCreator.createLayerWithCatalogItem(topicId, catalogItemParentId, layerSettingsVO, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Metoda pro vytvoření tématu
         * @param {TopicBaseVO} topicBaseVO Objekt tématu obsahující jen název
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createTopic(topicBaseVO: TopicBaseVO, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {

            const localVarAxiosArgs = await localVarAxiosParamCreator.createTopic(topicBaseVO, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Metoda pro odebrání catalog itemu / odebrání kategorie
         * @param {number} catalogItemId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteCatalogItem(catalogItemId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {

            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteCatalogItem(catalogItemId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Metoda pro odebrání vrstvy
         * @param {number} layerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteLayer(layerId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {

            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteLayer(layerId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Metoda pro smazání tématu
         * @param {string} topicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteTopic(topicId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {

            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteTopic(topicId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Metoda co vrátí všechny dostupné entity pro přiřazení práv dle fulltextu
         * @param {string} fulltext Filtr pro fulltextové vyhledání
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllEntitiesFulltext(fulltext: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<FulltextSearchResultVO>>> {

            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllEntitiesFulltext(fulltext, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Metoda pro vrácení vrstvy
         * @param {number} layerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLayer(layerId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LayerSettingsVO>> {

            const localVarAxiosArgs = await localVarAxiosParamCreator.getLayer(layerId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Metoda pro zjištění data a času, ke kterému jsou aktualizována data vrstvy ve veřejné instanci Mapia (maximum data poslední publikace ze záznamů vrstvy).
         * @param {number} layerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLayerDataUpdated(layerId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LayerDataUpdatedVO>> {

            const localVarAxiosArgs = await localVarAxiosParamCreator.getLayerDataUpdated(layerId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Metoda pro načtení stromu dle topic id, vrací plochou strukturu s vazbami children/parent
         * @param {string} topicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTopicTree(topicId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TopicTreeNodeVO>>> {

            const localVarAxiosArgs = await localVarAxiosParamCreator.getTopicTree(topicId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Metoda pro okamžité spuštění publikace jedné vrstvy do veřejné instance Mapia. Publikace běží na pozadí.
         * @param {number} layerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async publishLayer(layerId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {

            const localVarAxiosArgs = await localVarAxiosParamCreator.publishLayer(layerId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Metoda pro update catalog itemu / kategorie
         * @param {number} catalogItemId 
         * @param {CatalogItemDetailVO} [catalogItemDetailVO] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCatalogItem(catalogItemId: number, catalogItemDetailVO?: CatalogItemDetailVO, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {

            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCatalogItem(catalogItemId, catalogItemDetailVO, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Metoda pro update vrstvy
         * @param {number} layerId 
         * @param {LayerSettingsVO} layerSettingsVO Objekt vrstvy
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateLayer(layerId: number, layerSettingsVO: LayerSettingsVO, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {

            const localVarAxiosArgs = await localVarAxiosParamCreator.updateLayer(layerId, layerSettingsVO, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Metoda pro (od)označení selected fieldech prvků catalog item
         * @param {string} topicId 
         * @param {Array<CatalogItemSelectStateVO>} catalogItemSelectStateVO List identifikátorů catalog itemů, u kterých se má provést (un)select
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateSelectStates(topicId: string, catalogItemSelectStateVO: Array<CatalogItemSelectStateVO>, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {

            const localVarAxiosArgs = await localVarAxiosParamCreator.updateSelectStates(topicId, catalogItemSelectStateVO, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Metoda pro update tématu
         * @param {string} topicId 
         * @param {TopicBaseVO} topicBaseVO Objekt tématu
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateTopic(topicId: string, topicBaseVO: TopicBaseVO, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {

            const localVarAxiosArgs = await localVarAxiosParamCreator.updateTopic(topicId, topicBaseVO, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Metoda pro update settings tématu
         * @param {string} topicId 
         * @param {TopicLightVO} topicLightVO Objekt tématu
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateTopicSettings(topicId: string, topicLightVO: TopicLightVO, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {

            const localVarAxiosArgs = await localVarAxiosParamCreator.updateTopicSettings(topicId, topicLightVO, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * LayerSettingsControllerApi - factory interface
 * @export
 */
export const LayerSettingsControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = LayerSettingsControllerApiFp(configuration)
    return {
        /**
         * Metoda co slouží k převedení jednoho (či více) children od dárce k příjemci, případně k přeorganizování pořadí u příjemce.
         * @param {CatalogItemChildrenSwapVO} catalogItemChildrenSwapVO List identifikátorů catalog itemů, u kterých se uloží nové uspořádání jejich child elementů
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeChildrenOrder(catalogItemChildrenSwapVO: CatalogItemChildrenSwapVO, options?: any): AxiosPromise<void> {
            return localVarFp.changeChildrenOrder(catalogItemChildrenSwapVO, options).then((request) => request(axios, basePath));
        },
        /**
         * Metoda pro přidání catalog itemu / založení kategorie
         * @param {CatalogItemDetailVO} [catalogItemDetailVO] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCatalogItem(catalogItemDetailVO?: CatalogItemDetailVO, options?: any): AxiosPromise<number> {
            return localVarFp.createCatalogItem(catalogItemDetailVO, options).then((request) => request(axios, basePath));
        },
        /**
         * Metoda pro vytvoření vrstvy
         * @param {LayerSettingsVO} layerSettingsVO Objekt vrstvy
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createLayer(layerSettingsVO: LayerSettingsVO, options?: any): AxiosPromise<number> {
            return localVarFp.createLayer(layerSettingsVO, options).then((request) => request(axios, basePath));
        },
        /**
         * Metoda pro vytvoření vrstvy a její přidání do kategorie
         * @param {string} topicId 
         * @param {number} [catalogItemParentId] 
         * @param {LayerSettingsVO} [layerSettingsVO] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createLayerWithCatalogItem(topicId: string, catalogItemParentId?: number, layerSettingsVO?: LayerSettingsVO, options?: any): AxiosPromise<number> {
            return localVarFp.createLayerWithCatalogItem(topicId, catalogItemParentId, layerSettingsVO, options).then((request) => request(axios, basePath));
        },
        /**
         * Metoda pro vytvoření tématu
         * @param {TopicBaseVO} topicBaseVO Objekt tématu obsahující jen název
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTopic(topicBaseVO: TopicBaseVO, options?: any): AxiosPromise<string> {
            return localVarFp.createTopic(topicBaseVO, options).then((request) => request(axios, basePath));
        },
        /**
         * Metoda pro odebrání catalog itemu / odebrání kategorie
         * @param {number} catalogItemId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCatalogItem(catalogItemId: number, options?: any): AxiosPromise<void> {
            return localVarFp.deleteCatalogItem(catalogItemId, options).then((request) => request(axios, basePath));
        },
        /**
         * Metoda pro odebrání vrstvy
         * @param {number} layerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteLayer(layerId: number, options?: any): AxiosPromise<void> {
            return localVarFp.deleteLayer(layerId, options).then((request) => request(axios, basePath));
        },
        /**
         * Metoda pro smazání tématu
         * @param {string} topicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTopic(topicId: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteTopic(topicId, options).then((request) => request(axios, basePath));
        },
        /**
         * Metoda co vrátí všechny dostupné entity pro přiřazení práv dle fulltextu
         * @param {string} fulltext Filtr pro fulltextové vyhledání
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEntitiesFulltext(fulltext: string, options?: any): AxiosPromise<Array<FulltextSearchResultVO>> {
            return localVarFp.getAllEntitiesFulltext(fulltext, options).then((request) => request(axios, basePath));
        },
        /**
         * Metoda pro vrácení vrstvy
         * @param {number} layerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLayer(layerId: number, options?: any): AxiosPromise<LayerSettingsVO> {
            return localVarFp.getLayer(layerId, options).then((request) => request(axios, basePath));
        },
        /**
         * Metoda pro zjištění data a času, ke kterému jsou aktualizována data vrstvy ve veřejné instanci Mapia (maximum data poslední publikace ze záznamů vrstvy).
         * @param {number} layerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLayerDataUpdated(layerId: number, options?: any): AxiosPromise<LayerDataUpdatedVO> {
            return localVarFp.getLayerDataUpdated(layerId, options).then((request) => request(axios, basePath));
        },
        /**
         * Metoda pro načtení stromu dle topic id, vrací plochou strukturu s vazbami children/parent
         * @param {string} topicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTopicTree(topicId: string, options?: any): AxiosPromise<Array<TopicTreeNodeVO>> {
            return localVarFp.getTopicTree(topicId, options).then((request) => request(axios, basePath));
        },
        /**
         * Metoda pro okamžité spuštění publikace jedné vrstvy do veřejné instance Mapia. Publikace běží na pozadí.
         * @param {number} layerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publishLayer(layerId: number, options?: any): AxiosPromise<void> {
            return localVarFp.publishLayer(layerId, options).then((request) => request(axios, basePath));
        },
        /**
         * Metoda pro update catalog itemu / kategorie
         * @param {number} catalogItemId 
         * @param {CatalogItemDetailVO} [catalogItemDetailVO] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCatalogItem(catalogItemId: number, catalogItemDetailVO?: CatalogItemDetailVO, options?: any): AxiosPromise<void> {
            return localVarFp.updateCatalogItem(catalogItemId, catalogItemDetailVO, options).then((request) => request(axios, basePath));
        },
        /**
         * Metoda pro update vrstvy
         * @param {number} layerId 
         * @param {LayerSettingsVO} layerSettingsVO Objekt vrstvy
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateLayer(layerId: number, layerSettingsVO: LayerSettingsVO, options?: any): AxiosPromise<void> {
            return localVarFp.updateLayer(layerId, layerSettingsVO, options).then((request) => request(axios, basePath));
        },
        /**
         * Metoda pro (od)označení selected fieldech prvků catalog item
         * @param {string} topicId 
         * @param {Array<CatalogItemSelectStateVO>} catalogItemSelectStateVO List identifikátorů catalog itemů, u kterých se má provést (un)select
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSelectStates(topicId: string, catalogItemSelectStateVO: Array<CatalogItemSelectStateVO>, options?: any): AxiosPromise<void> {
            return localVarFp.updateSelectStates(topicId, catalogItemSelectStateVO, options).then((request) => request(axios, basePath));
        },
        /**
         * Metoda pro update tématu
         * @param {string} topicId 
         * @param {TopicBaseVO} topicBaseVO Objekt tématu
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTopic(topicId: string, topicBaseVO: TopicBaseVO, options?: any): AxiosPromise<void> {
            return localVarFp.updateTopic(topicId, topicBaseVO, options).then((request) => request(axios, basePath));
        },
        /**
         * Metoda pro update settings tématu
         * @param {string} topicId 
         * @param {TopicLightVO} topicLightVO Objekt tématu
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTopicSettings(topicId: string, topicLightVO: TopicLightVO, options?: any): AxiosPromise<void> {
            return localVarFp.updateTopicSettings(topicId, topicLightVO, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * LayerSettingsControllerApi - interface
 * @export
 * @interface LayerSettingsControllerApi
 */
export interface LayerSettingsControllerApiInterface {
    /**
     * Metoda co slouží k převedení jednoho (či více) children od dárce k příjemci, případně k přeorganizování pořadí u příjemce.
     * @param {CatalogItemChildrenSwapVO} catalogItemChildrenSwapVO List identifikátorů catalog itemů, u kterých se uloží nové uspořádání jejich child elementů
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LayerSettingsControllerApiInterface
     */
    changeChildrenOrder(catalogItemChildrenSwapVO: CatalogItemChildrenSwapVO, options?: any): AxiosPromise<void>;

    /**
     * Metoda pro přidání catalog itemu / založení kategorie
     * @param {CatalogItemDetailVO} [catalogItemDetailVO] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LayerSettingsControllerApiInterface
     */
    createCatalogItem(catalogItemDetailVO?: CatalogItemDetailVO, options?: any): AxiosPromise<number>;

    /**
     * Metoda pro vytvoření vrstvy
     * @param {LayerSettingsVO} layerSettingsVO Objekt vrstvy
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LayerSettingsControllerApiInterface
     */
    createLayer(layerSettingsVO: LayerSettingsVO, options?: any): AxiosPromise<number>;

    /**
     * Metoda pro vytvoření vrstvy a její přidání do kategorie
     * @param {string} topicId 
     * @param {number} [catalogItemParentId] 
     * @param {LayerSettingsVO} [layerSettingsVO] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LayerSettingsControllerApiInterface
     */
    createLayerWithCatalogItem(topicId: string, catalogItemParentId?: number, layerSettingsVO?: LayerSettingsVO, options?: any): AxiosPromise<number>;

    /**
     * Metoda pro vytvoření tématu
     * @param {TopicBaseVO} topicBaseVO Objekt tématu obsahující jen název
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LayerSettingsControllerApiInterface
     */
    createTopic(topicBaseVO: TopicBaseVO, options?: any): AxiosPromise<string>;

    /**
     * Metoda pro odebrání catalog itemu / odebrání kategorie
     * @param {number} catalogItemId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LayerSettingsControllerApiInterface
     */
    deleteCatalogItem(catalogItemId: number, options?: any): AxiosPromise<void>;

    /**
     * Metoda pro odebrání vrstvy
     * @param {number} layerId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LayerSettingsControllerApiInterface
     */
    deleteLayer(layerId: number, options?: any): AxiosPromise<void>;

    /**
     * Metoda pro smazání tématu
     * @param {string} topicId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LayerSettingsControllerApiInterface
     */
    deleteTopic(topicId: string, options?: any): AxiosPromise<void>;

    /**
     * Metoda co vrátí všechny dostupné entity pro přiřazení práv dle fulltextu
     * @param {string} fulltext Filtr pro fulltextové vyhledání
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LayerSettingsControllerApiInterface
     */
    getAllEntitiesFulltext(fulltext: string, options?: any): AxiosPromise<Array<FulltextSearchResultVO>>;

    /**
     * Metoda pro vrácení vrstvy
     * @param {number} layerId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LayerSettingsControllerApiInterface
     */
    getLayer(layerId: number, options?: any): AxiosPromise<LayerSettingsVO>;

    /**
     * Metoda pro zjištění data a času, ke kterému jsou aktualizována data vrstvy ve veřejné instanci Mapia (maximum data poslední publikace ze záznamů vrstvy).
     * @param {number} layerId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LayerSettingsControllerApiInterface
     */
    getLayerDataUpdated(layerId: number, options?: any): AxiosPromise<LayerDataUpdatedVO>;

    /**
     * Metoda pro načtení stromu dle topic id, vrací plochou strukturu s vazbami children/parent
     * @param {string} topicId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LayerSettingsControllerApiInterface
     */
    getTopicTree(topicId: string, options?: any): AxiosPromise<Array<TopicTreeNodeVO>>;

    /**
     * Metoda pro okamžité spuštění publikace jedné vrstvy do veřejné instance Mapia. Publikace běží na pozadí.
     * @param {number} layerId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LayerSettingsControllerApiInterface
     */
    publishLayer(layerId: number, options?: any): AxiosPromise<void>;

    /**
     * Metoda pro update catalog itemu / kategorie
     * @param {number} catalogItemId 
     * @param {CatalogItemDetailVO} [catalogItemDetailVO] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LayerSettingsControllerApiInterface
     */
    updateCatalogItem(catalogItemId: number, catalogItemDetailVO?: CatalogItemDetailVO, options?: any): AxiosPromise<void>;

    /**
     * Metoda pro update vrstvy
     * @param {number} layerId 
     * @param {LayerSettingsVO} layerSettingsVO Objekt vrstvy
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LayerSettingsControllerApiInterface
     */
    updateLayer(layerId: number, layerSettingsVO: LayerSettingsVO, options?: any): AxiosPromise<void>;

    /**
     * Metoda pro (od)označení selected fieldech prvků catalog item
     * @param {string} topicId 
     * @param {Array<CatalogItemSelectStateVO>} catalogItemSelectStateVO List identifikátorů catalog itemů, u kterých se má provést (un)select
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LayerSettingsControllerApiInterface
     */
    updateSelectStates(topicId: string, catalogItemSelectStateVO: Array<CatalogItemSelectStateVO>, options?: any): AxiosPromise<void>;

    /**
     * Metoda pro update tématu
     * @param {string} topicId 
     * @param {TopicBaseVO} topicBaseVO Objekt tématu
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LayerSettingsControllerApiInterface
     */
    updateTopic(topicId: string, topicBaseVO: TopicBaseVO, options?: any): AxiosPromise<void>;

    /**
     * Metoda pro update settings tématu
     * @param {string} topicId 
     * @param {TopicLightVO} topicLightVO Objekt tématu
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LayerSettingsControllerApiInterface
     */
    updateTopicSettings(topicId: string, topicLightVO: TopicLightVO, options?: any): AxiosPromise<void>;

}

/**
 * LayerSettingsControllerApi - object-oriented interface
 * @export
 * @class LayerSettingsControllerApi
 * @extends {BaseAPI}
 */
export class LayerSettingsControllerApi extends BaseAPI implements LayerSettingsControllerApiInterface {
    /**
     * Metoda co slouží k převedení jednoho (či více) children od dárce k příjemci, případně k přeorganizování pořadí u příjemce.
     * @param {CatalogItemChildrenSwapVO} catalogItemChildrenSwapVO List identifikátorů catalog itemů, u kterých se uloží nové uspořádání jejich child elementů
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LayerSettingsControllerApi
     */
    public changeChildrenOrder(catalogItemChildrenSwapVO: CatalogItemChildrenSwapVO, options?: any) {
        return LayerSettingsControllerApiFp(this.configuration).changeChildrenOrder(catalogItemChildrenSwapVO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Metoda pro přidání catalog itemu / založení kategorie
     * @param {CatalogItemDetailVO} [catalogItemDetailVO] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LayerSettingsControllerApi
     */
    public createCatalogItem(catalogItemDetailVO?: CatalogItemDetailVO, options?: any) {
        return LayerSettingsControllerApiFp(this.configuration).createCatalogItem(catalogItemDetailVO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Metoda pro vytvoření vrstvy
     * @param {LayerSettingsVO} layerSettingsVO Objekt vrstvy
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LayerSettingsControllerApi
     */
    public createLayer(layerSettingsVO: LayerSettingsVO, options?: any) {
        return LayerSettingsControllerApiFp(this.configuration).createLayer(layerSettingsVO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Metoda pro vytvoření vrstvy a její přidání do kategorie
     * @param {string} topicId 
     * @param {number} [catalogItemParentId] 
     * @param {LayerSettingsVO} [layerSettingsVO] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LayerSettingsControllerApi
     */
    public createLayerWithCatalogItem(topicId: string, catalogItemParentId?: number, layerSettingsVO?: LayerSettingsVO, options?: any) {
        return LayerSettingsControllerApiFp(this.configuration).createLayerWithCatalogItem(topicId, catalogItemParentId, layerSettingsVO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Metoda pro vytvoření tématu
     * @param {TopicBaseVO} topicBaseVO Objekt tématu obsahující jen název
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LayerSettingsControllerApi
     */
    public createTopic(topicBaseVO: TopicBaseVO, options?: any) {
        return LayerSettingsControllerApiFp(this.configuration).createTopic(topicBaseVO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Metoda pro odebrání catalog itemu / odebrání kategorie
     * @param {number} catalogItemId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LayerSettingsControllerApi
     */
    public deleteCatalogItem(catalogItemId: number, options?: any) {
        return LayerSettingsControllerApiFp(this.configuration).deleteCatalogItem(catalogItemId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Metoda pro odebrání vrstvy
     * @param {number} layerId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LayerSettingsControllerApi
     */
    public deleteLayer(layerId: number, options?: any) {
        return LayerSettingsControllerApiFp(this.configuration).deleteLayer(layerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Metoda pro smazání tématu
     * @param {string} topicId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LayerSettingsControllerApi
     */
    public deleteTopic(topicId: string, options?: any) {
        return LayerSettingsControllerApiFp(this.configuration).deleteTopic(topicId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Metoda co vrátí všechny dostupné entity pro přiřazení práv dle fulltextu
     * @param {string} fulltext Filtr pro fulltextové vyhledání
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LayerSettingsControllerApi
     */
    public getAllEntitiesFulltext(fulltext: string, options?: any) {
        return LayerSettingsControllerApiFp(this.configuration).getAllEntitiesFulltext(fulltext, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Metoda pro vrácení vrstvy
     * @param {number} layerId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LayerSettingsControllerApi
     */
    public getLayer(layerId: number, options?: any) {
        return LayerSettingsControllerApiFp(this.configuration).getLayer(layerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Metoda pro zjištění data a času, ke kterému jsou aktualizována data vrstvy ve veřejné instanci Mapia (maximum data poslední publikace ze záznamů vrstvy).
     * @param {number} layerId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LayerSettingsControllerApi
     */
    public getLayerDataUpdated(layerId: number, options?: any) {
        return LayerSettingsControllerApiFp(this.configuration).getLayerDataUpdated(layerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Metoda pro načtení stromu dle topic id, vrací plochou strukturu s vazbami children/parent
     * @param {string} topicId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LayerSettingsControllerApi
     */
    public getTopicTree(topicId: string, options?: any) {
        return LayerSettingsControllerApiFp(this.configuration).getTopicTree(topicId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Metoda pro okamžité spuštění publikace jedné vrstvy do veřejné instance Mapia. Publikace běží na pozadí.
     * @param {number} layerId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LayerSettingsControllerApi
     */
    public publishLayer(layerId: number, options?: any) {
        return LayerSettingsControllerApiFp(this.configuration).publishLayer(layerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Metoda pro update catalog itemu / kategorie
     * @param {number} catalogItemId 
     * @param {CatalogItemDetailVO} [catalogItemDetailVO] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LayerSettingsControllerApi
     */
    public updateCatalogItem(catalogItemId: number, catalogItemDetailVO?: CatalogItemDetailVO, options?: any) {
        return LayerSettingsControllerApiFp(this.configuration).updateCatalogItem(catalogItemId, catalogItemDetailVO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Metoda pro update vrstvy
     * @param {number} layerId 
     * @param {LayerSettingsVO} layerSettingsVO Objekt vrstvy
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LayerSettingsControllerApi
     */
    public updateLayer(layerId: number, layerSettingsVO: LayerSettingsVO, options?: any) {
        return LayerSettingsControllerApiFp(this.configuration).updateLayer(layerId, layerSettingsVO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Metoda pro (od)označení selected fieldech prvků catalog item
     * @param {string} topicId 
     * @param {Array<CatalogItemSelectStateVO>} catalogItemSelectStateVO List identifikátorů catalog itemů, u kterých se má provést (un)select
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LayerSettingsControllerApi
     */
    public updateSelectStates(topicId: string, catalogItemSelectStateVO: Array<CatalogItemSelectStateVO>, options?: any) {
        return LayerSettingsControllerApiFp(this.configuration).updateSelectStates(topicId, catalogItemSelectStateVO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Metoda pro update tématu
     * @param {string} topicId 
     * @param {TopicBaseVO} topicBaseVO Objekt tématu
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LayerSettingsControllerApi
     */
    public updateTopic(topicId: string, topicBaseVO: TopicBaseVO, options?: any) {
        return LayerSettingsControllerApiFp(this.configuration).updateTopic(topicId, topicBaseVO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Metoda pro update settings tématu
     * @param {string} topicId 
     * @param {TopicLightVO} topicLightVO Objekt tématu
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LayerSettingsControllerApi
     */
    public updateTopicSettings(topicId: string, topicLightVO: TopicLightVO, options?: any) {
        return LayerSettingsControllerApiFp(this.configuration).updateTopicSettings(topicId, topicLightVO, options).then((request) => request(this.axios, this.basePath));
    }
}
